export default {
  status: 0,
  room: null,
  softPhone: null,
  audioTrack: null,
  noCalls: false,
  currentCall: {},
  callListId: null,
  keepCalling: false,
  reconnecting: false,
  disconnectReason: {},
  reconnectionDelay: 10,
  reconnectionAttempts: 3,
  disconnectionTimeout: '',
  isCampaignTransfer: false,
  currentStatusStartTime: 0,
  retryConnection: false,
  disconnectReasons: [
    {
      id: 2,
      name: 'Check out',
    },
    {
      id: 3,
      name: 'Lunch',
    },
    {
      id: 4,
      name: 'Bathroom',
    },
    {
      id: 6,
      name: 'Meeting',
    },
    {
      id: 7,
      name: 'Break',
    },
    {
      id: 8,
      name: 'Internet failure',
    },
    {
      id: 13,
      name: 'Recharge',
    },
    {
      id: 9,
      name: 'Other',
    },
    {
      id: 18,
      name: 'Application failure',
    },
    {
      id: 19,
      name: 'Post-Call Documentation',
    }
  ],
  loading: false,
};



// WEBPACK FOOTER //
// ./src/store/dialer_v2/state.js